import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

import {
    DashboardFetch,
    IARDashboardAging,
    IARDashboardCustomerDelay,
    IARDashboardCustomerList,
    IARDashboardCustomerDue,
    IARDashboardDSOTrend,
    IARDashboardInvoices,
    IARDashboardNumbers,
    IARDashboardSales,
    IARDashboardTagInvoices,
    IARDashboardPaymentMode,
} from "../../utils/ARDashboard.types";

/**
 * Fetch AR Dashboard numbers async thunk.
*/
export const fetchARDashboardNumbers = createAsyncThunk(
    'dashboard/numbers/ar',
    async ({accountId,  params}:DashboardFetch): Promise<IARDashboardNumbers> => {
        let queryParam = (params)? `${params}`: ''
        const response = await axios.get(`/api/v1/dashboard/ar/numbers/${accountId}?${queryParam}`);

        return response.data;
    }
);

/**
 * Fetch AR Dashboard sales async thunk.
*/
export const fetchARDashboardSales = createAsyncThunk(
    'dashboard/sales/ar',
    async ({accountId,  params}:DashboardFetch): Promise<IARDashboardSales> => {
        let queryParam = (params)? `${params}`: ''
        const response = await axios.get(`/api/v1/dashboard/ar/sales/${accountId}?${queryParam}`);

        return response.data;
    }
);

/**
 * Fetch AR Dashboard invoices async thunk.
*/
export const fetchARDashboardInvoices = createAsyncThunk(
    'dashboard/invoices/ar',
    async ({accountId,  params}:DashboardFetch): Promise<IARDashboardInvoices> => {
        let queryParam = (params)? `${params}`: ''
        const response = await axios.get(`/api/v1/dashboard/ar/invoices/${accountId}?${queryParam}`);

        return response.data;
    }
);

/**
 * Fetch AR Dashboard tag-wise invoice counts async thunk.
*/
export const fetchARDashboardTagInvoices = createAsyncThunk(
    'dashboard/tag-invoices/ar',
    async ({accountId,  params}:DashboardFetch): Promise<IARDashboardTagInvoices> => {
        let queryParam = (params)? `${params}`: ''
        const response = await axios.get(`/api/v1/dashboard/ar/tag-invoices/${accountId}?${queryParam}`);

        return response.data;
    }
);

/**
 * Fetch AR Dashboard payment-mode breakup async thunk.
*/
export const fetchARDashboardPaymentMode = createAsyncThunk(
    'dashboard/payment-mode/ar',
    async ({accountId,  params}:DashboardFetch): Promise<IARDashboardPaymentMode> => {
        let queryParam = (params)? `${params}`: ''
        const response = await axios.get(`/api/v1/dashboard/ar/payment-mode/${accountId}?${queryParam}`);

        return response.data;
    }
);

/**
 * Fetch AR Dashboard aging async thunk.
*/
export const fetchARDashboardAging = createAsyncThunk(
    'dashboard/aging/ar',
    async ({accountId,  params}:DashboardFetch): Promise<IARDashboardAging> => {
        let queryParam = (params)? `${params}`: ''
        const response = await axios.get(`/api/v1/dashboard/ar/aging/${accountId}?${queryParam}`);

        return response.data;
    }
);

/**
 * Fetch AR Dashboard DSO trend async thunk.
*/
export const fetchARDashboardDSOTrend = createAsyncThunk(
    'dashboard/dsotrend/ar',
    async ({accountId,  params}:DashboardFetch): Promise<IARDashboardDSOTrend> => {
        let queryParam = (params)? `${params}`: ''
        const response = await axios.get(`/api/v1/dashboard/ar/dso-trend/${accountId}?${queryParam}`);

        return response.data;
    }
);

/**
 * Fetch AR Dashboard Top Customers with amount due async thunk.
*/
export const fetchARDashboardCustomersDue = createAsyncThunk(
    'dashboard/customerdue/ar',
    async ({accountId,  params}:DashboardFetch): Promise<IARDashboardCustomerDue> => {
        let queryParam = (params)? `${params}`: ''
        const response = await axios.get(`/api/v1/dashboard/ar/customer-due/${accountId}?${queryParam}`);

        return response.data;
    }
);

/**
 * Fetch AR Dashboard Top Customers list with amount due async thunk.
*/
export const fetchARDashboardCustomersListDue = createAsyncThunk(
    'dashboard/customerListdue/ar',
    async ({accountId,  params}:DashboardFetch): Promise<IARDashboardCustomerList> => {
        let queryParam = (params)? `${params}`: ''
        const response = await axios.get(`/api/v1/dashboard/ar/customer-list-due/${accountId}?${queryParam}`);

        return response.data;
    }
);

/**
 * Fetch AR Dashboard Top Customers with delay async thunk.
*/
export const fetchARDashboardCustomersDelay = createAsyncThunk(
    'dashboard/customerdelay/ar',
    async ({accountId,  params}:DashboardFetch): Promise<IARDashboardCustomerDelay> => {
        let queryParam = (params)? `${params}`: ''
        const response = await axios.get(`/api/v1/dashboard/ar/customer-delay/${accountId}?${queryParam}`);

        return response.data;
    }
);

/**
 * Fetch AR Dashboard Customers with delay list async thunk.
*/
export const fetchARDashboardListCustomersDelay = createAsyncThunk(
    'dashboard/customerdelaylist/ar',
    async ({accountId,  params}:DashboardFetch): Promise<IARDashboardCustomerList> => {
        let queryParam = (params)? `${params}`: ''
        const response = await axios.get(`/api/v1/dashboard/ar/customer-list-delay/${accountId}?${queryParam}`);

        return response.data;
    }
);

